import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Enquiries from "./pages/enquiry/Enquiries";
import Courses from "./pages/academicPortal/course/Courses";
import Subjects from "./pages/academicPortal/subject/Subjects";
import Students from "./pages/student/Students";
import StudentsReport from "./pages/student/StudentReport";
import RTEStudentList from "./pages/student/RTEStudentList";
import FeeReceipt from "./pages/students/FeeReceipt";
import Attendancemonth from "./pages/main/Attendance/Attendancemonth";
import Batches from "./pages/academicPortal/batch/Batches";
import BatchDetail from "./pages/academicPortal/batch/BatchDetail";
import Teachers from "./pages/main/Teachers/Teachers";
import UpdateStaffForm from "./pages/main/Teachers/UpdateStaffDetails";
import AddStaff from "./pages/main/Teachers/AddStaff";
import EditStaff from "./pages/main/Teachers/EditStaff";
import GatePass from "./pages/main/Gatepass/GatePass";
import Testlist from "./pages/main/testsList/testsList";
import TestExcelMarksUpload from "./pages/main/testsList/TestExcelMarksUploadV2";
import Testsview from "./pages/main/testsList/Testsview";
import Testreport from "./pages/main/testsList/v2/Testreport";
import ProgessCard from "./pages/main/testsList/v2/ProgessCard";
import Bus from "./pages/buses/Bus";
import BusStudentview from "./pages/buses/Bus_studentview";
import FeeCollection from "./pages/main/Fee Collection/FeeCollection";
import FeeCollectionV2 from "./pages/FeeCollectionv2/FeeCollection";
import FeeFollowupV2 from "./pages/FeeCollectionv2/FeeFollowup";
import FeesReportDashboard from "./pages/FeeCollectionv2/FeesReportDashboard";
import StudentDueFees from "./pages/FeeCollectionv2/StudentDueFees";
import StudentDueRegistration from "./pages/FeeCollectionv2/StudentDueRegistration";
import KitManagement from "./pages/main/Kit Management/KitManagement";
import AllBatchKit from "./pages/main/Kit Management/AllBatchKitTransaction";
import KitTransaction from "./pages/main/Kit Management/KitTransaction";
import Kitview from "./pages/main/Kit Management/Kitview";
import Marketings from "./pages/main/Marketings/Marketings";
import Allstudent from "./pages/main/Marketings/Allstudents";
import FollowUpForm from "./pages/main/Marketings/Followupdata";
import Sessions from "./pages/academicPortal/session/Sessions";
import Banner from "./pages/main/Settings/Banner";
import Settings from "./pages/settings/Settings";
import UsersPage from "./pages/main/Settings/Users";
import CollectionReports from "./pages/main/Collection Reports/Collection Reports";
import CertificateMarksheet from "./pages/main/Certificate/CertificateMarksheet";
import CertificateReportcard from "./pages/main/Certificate/CertificateReportcard";
import CertificateReceipt from "./pages/main/Certificate/CertificateReceipt";
import BirthdayCard from "./pages/main/Birthday/BirthdayCard";
import Rte from "./pages/rteManagement/Rte";
import PayRoll from "./pages/main/Payroll/PayRoll";
import AddNewPayroll from "./pages/main/Payroll/AddPayroll";
import AddMarketingSchool from "./pages/main/Marketings/AddMarketingSchool";
import UpdateMarketingSchool from "./pages/main/Marketings/UpdateMarketingSchool";
import StudentForm from "./pages/main/Marketings/StudentForm";
import UpdateMarketingStudent from "./pages/main/Marketings/UpdateMarketingStudent";
import CreateGatePass from "./pages/main/Gatepass/CrateGatePass";
import AddNewTest from "./pages/main/testsList/v2/AddNewTest";
import PayRollview from "./pages/main/Payroll/PayRollview";
import GatePassupdata from "./pages/main/Gatepass/Gatepassupdata";
import UpdateTest from "./pages/main/testsList/v2/UpdateTest";
import FollowUp from "./pages/main/FollowUp/FollowUp";
import ChooseIdCard from "./pages/main/Id Card/ChooseIdCard";
import HostelProfile from "./pages/hostel/v2/profile";
import TestResultsTable from "./pages/students/MarksReport";
import KitsDetailsTable from "./pages/students/KitsDetails";
import CourseFeeInfo from "./pages/students/CourseFeeInfo";
import BusRoutes from "./pages/buses/BusRoutes";
import BusStudents from "./pages/buses/BusStudents";
import UserNewRole from "./pages/main/Settings/UserNewRole";
import AppDownload from "./pages/master/AppDownload";
import Application from "./pages/main/Settings/Application";
import StaffAttendance from "./pages/main/Attendance/StaffAttendance";
import DemoSstudent from "./pages/main/Attendance/DemoSstudent";
import DemoMonthAttendance from "./pages/main/Attendance/DemoMonthAttendance";
import StaffMonthAttendance from "./pages/main/Attendance/StaffMonthAttendance";
import AlocateData from "./pages/main/FollowUp/AlocateData";
import Assign from "./pages/main/calling/Assign";
import CounselorCall from "./pages/main/calling/CounselorCall";
import Cleander from "./pages/main/clender/cleander";
import NewForm from "./pages/students/NewForm";
import FeeFollowUpResponse from "./pages/main/Fee Collection/FeeFollowUpResponse";
import UpdateUserRole from "./pages/main/Settings/UpdateUserRole";
import Index3 from "./pages/Index3";
import Reports2 from "./pages/main/Reports/Reports2";
import AnnualTest from "./pages/main/testsList/AnnualTest";
import Teacherview2 from "./pages/main/Teachers/TeacherView2";
import StudentProfile2 from "./pages/students/v2/profile";
import DocumentCategory from "./pages/Documents/DocumentCategory";
import MarksheetSample from "./pages/main/testsList/MarksheetSample";
import HostelMain from "./pages/hostel/Main";
import HostelDashboard from "./pages/hostel/Dashboard";
import HostelStudents from "./pages/hostel/Students";
import HostelRooms from "./pages/hostel/Rooms";
import Hostels from "./pages/hostel/Hostels";
import HostelFeesDeposit from "./pages/hostel/FeeDeposit";
import HostelFeesPay from "./pages/hostel/HostelFeesPay";
import HostelFeeReceipt from "./pages/hostel/HostelFeeReceipt";
import HostelExpenses from "./pages/hostel/Expenses";
import HostelExpenseCategory from "./pages/hostel/ExpenseCategory";
import HostelReport from "./pages/hostel/Reports";
import HostelStudentAdd from "./pages/hostel/StudentAdd";
import Expenses from "./pages/expenses/Expenses";
import ExpenseCategory from "./pages/expenses/ExpenseCategory";
import Schedule from "./pages/timeTable/Schedule";
import Timetable from "./pages/timeTable/TimeTable";
import Staffs from "./pages/staffs/Staffs";
import StaffAdd from "./pages/staffs/StaffAdd";
import FeeCollectionFollowup from "./pages/main/Fee Collection/FeeCollectionFollowup";
import IdCard3 from "./pages/main/Id Card/IdCard3";
import BioMetricData from "./pages/main/Attendance/BioMetricData";
import AnnualTable from "./pages/main/testsList/v2/AnnualTable";
import DocumentCollection from "./pages/Documents/DocumentCollection";
import DocumentsDistribution from "./pages/Documents/DocumentsDistribution";
import AddDocument from "./pages/Documents/AddDocument";
import StaffUpdate from "./pages/staffs/StaffUpdate";
import SyllabusView from "./pages/courses/SyllabusView";
import SourceAssign from "./pages/main/Marketings/SourceAssign";
import SyllabusUpdate from "./pages/courses/syllabusUpdate";
import SyllabusManagement from "./pages/courses/syllabusManagement";
import SyllabusAssign from "./pages/courses/SyllabusAssign";
import SyllabusAssignForm from "./pages/courses/syllabusAssignForm";
import SyllabusAssignUpdate from "./pages/courses/syllabusAssignUpdate";
import IdCardV3 from "./pages/main/Id Card/IdCardV3";
import IdCardV3Staff from "./pages/main/Id Card/IdCardV3Staff";
import ProfileUpdate from "./pages/main/Id Card/StudentProfileUpdate";
import StaffSetting from "./pages/staffs/StaffsSetting";
import FeeReport from "./pages/main/Reports/FeesReport";
import FeeDue from "./pages/main/Reports/FeeDue";
import CreditDebit from "./pages/main/Reports/CreditDebit";
import ExpenseReport from "./pages/main/Reports/ExpenseReport";
import Alert from "./pages/main/Settings/Alert";
import BankAccount from "./pages/main/Settings/BankAccount";
import StaffReport from "./pages/main/Reports/StaffReport";
import BankFundTransfer from "./pages/main/Settings/BankFundTransfer";
import StudentCreateSource from "./pages/main/Marketings/StudentCreateSource";
import AdmitCard from "./pages/main/Certificate/AdmitCard";
import HostelBankAccount from "./pages/hostel/BankAccount";
import HostelFundTransfer from "./pages/hostel/BankFundTransfer";
import HostelExpenseReport from "./pages/hostel/ReportExpense";
import HostelFeeReport from "./pages/hostel/ReportFee";
import HostelFeeDue from "./pages/hostel/FeeDueReport";
import HostelMonthlyReport from "./pages/hostel/HostelMonthlyReport";
import HotelCreditDebit from "./pages/hostel/CreditDebit";
import StudentsList from "./pages/students/studentsList";
import WorkingSchedule from "./pages/staffs/WorkingSchedule";
// import Notice from "./pages/Academic/Notice";
import Holiday from "./pages/Academic/Holiday";
import HomeWork from "./pages/Academic/HomeWork";
import Gallery from "./pages/Academic/Gallery";
import ExperienceCertificate from "./pages/staffs/ExperienceCertificate";
import PageError from "./pages/Errors/404";
import ApiNotFound from "./pages/Errors/ApiNotFound";
import AccessDenied from "./pages/Errors/AccessDenied";
import ServerError from "./pages/Errors/server";
import StudentPortal from "./pages/students/v2/StudentPortal";
import AddmissionForm from "./pages/students/v2/AddmissionForm";
import ExamTest from "./pages/main/testsList/ExamTest";
import TypeWriter from "./pages/main/testsList/TypeWriter";
import ScheduleCreate from "./pages/staffs/ScheduleCreate";
import BanksAdd from "./pages/Accounts/BanksAdd";
import FundTarnsfer from "./pages/Accounts/FundTarnsfer";
import AdmitStudentBus from "./pages/buses/AdmitStudentBus";
import SalarySlip from "./pages/staffs/SalarySlip";
import BatchAdd from "./pages/academicPortal/batch/BatchAdd";
import Print from "./pages/Print/Print";
import MeritStudent from "./pages/students/v2/MeritStudent";
import CCCertificate from "./pages/staffs/CCCertificate";
import Moketestdasbrd from "./pages/mokTest/Dasbord";
import TestSerieas from "./pages/mokTest/TestSerieas";
import MockTestList from "./pages/mokTest/MockTestList";
import OnlineTest from "./pages/mokTest/OnlineTest";
import Distributedlist from "./pages/Documents/Distributedlist";
import CreateMockTest from "./pages/mokTest/CreateMockTest";
import BioMetricDevice from "./pages/main/Attendance/BIoMetricDevice";
import HostelStudentAttendance from "./pages/hostel/studentAttendance/HostelStudentAttendance";
import HostelStudentAttendanceList from "./pages/hostel/studentAttendance/HostelStudentAttendanceList";
import HostelStudentAttendanceListMonthly from "./pages/hostel/studentAttendance/HostelStudentAttendanceListMonthly";
import ClientVerify from "./pages/auth/ClientVerify";
import Login from "./pages/auth/Login";
import Logout from "./pages/auth/Logout";
import Profile from "./pages/settings/Profile";
import Role from "./pages/role/Role";
import RoleAdd from "./pages/role/RoleAdd";
import RoleUpdate from "./pages/role/RoleUpdate";
import RoleView from "./pages/role/RoleView";
import StudentsReviews from "./pages/reviews/StudentsReviews";
import AdditionDetails from "./pages/settings/AdditionDetails";
import BatchUpdate from "./pages/academicPortal/batch/BatchUpdate";
import StudentDocuments from "./pages/collectionDistribution/Collections";
import DocumentsType from "./pages/collectionDistribution/Categories";
import StudentDocumentsAdd from "./pages/collectionDistribution/CollectionAdd";
import CollectionUpdate from "./pages/collectionDistribution/CollectionUpdate";
import EnquiryAdd from "./pages/enquiry/EnquiryAdd";
import StudentFrom from "./pages/student/StudentAdmissionFormPrint";
import EnquiryUpdate from "./pages/enquiry/EnquiryUpdate";
import FeedbackView from "./pages/Feedback/FeedbackView";
import StudentIdCard from "./pages/idCards/StudentIdCard";
import StudentCharacterCertificate from "./pages/idCards/StudentCharacterCertificate";
import StudentTransferCertificate from "./pages/idCards/StudentTransferCertificate";
import Libraries from "./pages/library/Libraries";
import StudentMarksheet from "./pages/marksheet/StudentMarksheet";
import LibraryStudents from "./pages/library/Students";
import LibraryStudentAdd from "./pages/library/StudentAdd";
import LibrarySeats from "./pages/library/Seats";
import BusStudentAttendanceList from "./pages/bus/BusStudentAttendanceList";
import MarksheetReport from "./pages/main/testsList/MarksheetReport";
import AllBranchList from "./pages/branch/BranchLists";
import StudentTransferBranch from "./pages/branch/StudentTransfer";
import BranchAdd from "./admin/pages/BranchAdd";
import StudentTransferList from "./pages/branch/StudentTransferList";
import HostelStudentIdCard from "./pages/hostel/HostelStudentIdCard";
import HostelStudentTransfer from "./pages/hostel/HostelStudentTransfer";
import StudentDemo from "./pages/student/StudentDemo";
import Mess from "./pages/mess/Mess";
import MessEnrollList from "./pages/mess/MessEnrollList";
import MessEnroll from "./pages/mess/MessEnroll";
import MessAttendanceList from "./pages/mess/MessAttendanceList";
import MessGuestCard from "./pages/mess/MessGuestCard";
import LibraryShifts from "./pages/library/Shifts";
import LibraryStudentProfile from "./pages/library/StudentProfile";
import LibraryFees from "./pages/library/LibraryFees";
import LibraryDues from "./pages/library/LibraryDues";
import StudentFeeDeposit from "./pages/fees/StudentFeeDeposit";
import StudentFeeReceipt from "./pages/fees/StudentFeeReceipt";
import StudentDetails from "./pages/student/StudentDetails";
import StudentV2Details from "./pages/student_v2/StudentDetails";
import BasicV2Details from "./pages/student_v2/BasicDetails";
import CourseNFees from "./pages/student_v2/CourseNFees";
import FeeTransactions from "./pages/reports/FeeTransactions";
import StudentBatchTransfer from "./pages/student/StudentBatchTransfer";
import Assignment from "./pages/Assignments/AssignmentList";
import AssignmentAdd from "./pages/Assignments/AssignmentAdd";
import AssignmentView from "./pages/Assignments/AssignmentView";
import StudentAdd from "./pages/student/StudentAdd";
import CourseAdd from "./pages/academicPortal/course/CourseAdd";
import CourseUpdate from "./pages/academicPortal/course/CourseUpdate";
import EnquiryDetail from "./pages/enquiry/EnquiryDetail";
import EnquiryFollowups from "./pages/enquiry/EnquiryFollowups";
import EnquiryReports from "./pages/enquiry/EnquiryReports";
import Attendance from "./pages/main/Attendance/Attendance";
import AppConfiguration from "./pages/config/AppConfiguration";
import PrivateRoute from "./pages/config/PrivateRoute";
import EnquiryFormPrint from "./pages/enquiry/EnquiryFormPrint";
import EnquiryDemoFormPrint from "./pages/enquiry/EnquiryDemoFormPrint";
import StudentEnrollBatch from "./pages/student/StudentEnrollBatch";
import StudentEnrollBus from "./pages/student/StudentEnrollBus";
import StudentAdmissionFormPrint from "./pages/student/StudentAdmissionFormPrint";
import StudentDemoFormPrint from "./pages/student/StudentDemoFormPrint";
import StudentUpdate from "./pages/student/StudentUpdate";
import StudentLoginStatus from "./pages/student/StudentLoginStatus";
import Help from "./pages/help/Help";
import IssueList from "./pages/help/IssueList";
import { useOpenFilterCanvasShortcut } from "./pages/master/SortKey";
import StudentAttendanceDashboard from "./pages/attendance/StudentAttendanceDashboard";
import StudentAttendances from "./pages/attendance/StudentAttendances";
import StudentAttendancesMonthly from "./pages/attendance/StudentAttendancesMonthly";
import StudentAttendancesAnnual from "./pages/attendance/StudentAttendancesAnnual";
import StudentAttendanceFollowups from "./pages/attendance/reports/StudentAttendanceFollowups.jsx";
import StaffAttendanceDashboard from "./pages/attendance/StaffAttendanceDashboard";
import StaffAttendances from "./pages/attendance/StaffAttendances";
import StaffAttendancesMonthly from "./pages/attendance/StaffAttendancesMonthlyV2";
import DevicesList from "./pages/attendance/biometric/DevicesList";
import DevicesLogs from "./pages/attendance/biometric/DevicesLogs";
import EsslRegisteredUsers from "./pages/attendance/biometric/EsslRegisteredUsers";
import Items from "./pages/collectionDistribution/Items";
import ItemFields from "./pages/collectionDistribution/ItemFields";
import DistributionEntry from "./pages/collectionDistribution/DistributionEntry";
import Holidays from "./pages/attendance/holidays/Holidays";
import HolidaysAdd from "./pages/attendance/holidays/HolidaysAdd";
import HolidaysUpdate from "./pages/attendance/holidays/HolidaysUpdate";
import LeaveRequest from "./pages/attendance/holidays/LeaveRequest";
import MetaWaHistory from "./pages/message/meta/MetaWaHistory";
import MetaWaTemplates from "./pages/message/meta/MetaWaTemplates";
import MetaWaSendMsg from "./pages/message/meta/MetaWaSendMsgV2";
import MetaWaWallet from "./pages/message/meta/MetaWaWallet";
import MessagesList from "./pages/message/MessagesList";
import MessagesUpdate from "./pages/message/MessageUpdate";
import initGlobalInputFormatter from "./utils/globalInputFormatter.js";
import AdminDashboard from "./admin/pages/Dashboard";
import AdminStudentReport from "./admin/pages/StudentReport";
import AdminBranchList from "./admin/pages/BranchList";
import FinanceReport from "./admin/pages/FinanceReport";
import MessagesAdd from "./pages/message/MessagesAdd";
import RazorpaySettings from "./pages/settings/RazorpaySettings";
import StaffSalaryPay from "./pages/staffs/StaffSalaryPay";
import LibraryDashboard from "./pages/library/LibraryDashboard";
import StaffReportDashboard from "./pages/staffs/StaffReportDashboard";
import StudentEnrollBatchV4 from "./pages/student/v4/StudentEnrollBatchV4";
import StudentDetailsV4 from "./pages/student/v4/StudentDetailsV4";
import StudentFeeDepositV4 from "./pages/fees/StudentFeeDepositV4";
import StudentReportV4 from "./pages/student/v4/StudentReportV4";
import FeeCollectionV4 from "./pages/FeeCollectionv2/FeeCollectionV4";
import FeesReport from "./pages/studentFeeReport/FeesReport";
import FeesTransactions from "./pages/studentFeeReport/FeesTransactions";
import StudentFeeMismatchReport from "./pages/studentFeeReport/StudentFeeMismatchReport";
import StudentFeeDueReport from "./pages/studentFeeReport/StudentFeeDueReport";
import RTETransaction from "./pages/student/RTETransactions";
import StudentFeeDueTypeWise from "./pages/studentFeeReport/StudentFeeDueTypeWise";
import BatchDueFeesReport from "./pages/studentFeeReport/BatchDueFeesReport";
import StudentDetailsV5 from "./pages/student/v5/StudentDetailsV5";
import DiscountOffersList from "./pages/academicPortal/discountOffer/DiscountOffersList";
import DiscountOfferAdd from "./pages/academicPortal/discountOffer/DiscountOfferAdd";
import DiscountOfferUpdate from "./pages/academicPortal/discountOffer/DiscountOfferUpdate";
import StudentFeeReport from "./pages/studentFeeReport/StudentFeeReport";
import StudentFeeDiscountReport from "./pages/studentFeeReport/StudentFeeDiscountReport";
import StudentsOnlyV1 from "./pages/studentImport/v1/StudentsOnly.jsx";
import StudentsBatchEnrollV1 from "./pages/studentImport/v1/StudentsBatchEnroll.jsx";
import BatchDueFeesReportAllStudents from "./pages/studentFeeReport/BatchDueFeesReportAllStudents.jsx";
import StudentSubjectsAndFeeUp from "./pages/student/v5/tabs/StudentSubjectsAndFeeUp.jsx";
import BatchFeesEdit from "./pages/studentFeeReport/BatchFeesEdit.jsx";
import StudentsImportV5 from "./pages/student/v4/StudentsImportV5.jsx";
import StudentsDuplicate from "./pages/student/StudentDuplicate.jsx";
import AllFeesTransactions from "./pages/studentFeeReport/AllFeesTransactions.jsx";
import StudentFeeUpdateV1 from "./pages/student/v4/UpdateFeeNInfo.jsx";
import StudentDiscountOfferApply from "./pages/student/import/StudentDiscountOfferApply.jsx";
import StaffWorkReports from "./pages/Academic/Staffworkreports.jsx";
import StudentBusEnroll from "./pages/transport/StudentBusEnroll.jsx";
import BusRouteStopList from "./pages/transport/BusRouteStopList.jsx";
import BusList from "./pages/transport/BusList.jsx";
import BusStudentList from "./pages/transport/BusStudentList.jsx";
import TransportReport from "./pages/transport/TransportReport.jsx";
import StudentManualFeeDeposit from "./pages/fees/StudentManualFeeDeposit.jsx";
import BusStudentIdCardPage from "./pages/transport/BusStudentIdCardPage.jsx";
import BusStopImport from "./pages/transport/BusStopImport.jsx";
import BusStudentImport from "./pages/transport/BusStudentImport.jsx";
import FeesTransactionsV2 from "./pages/studentFeeReport/FeesTransactionsV2.jsx";
import TestGrading from "./pages/Grading/Testgrading.jsx";
import TimetableManage from "./pages/timeTable/TimetableManage.jsx";
import TimetableDayWise from "./pages/timeTable/TimetableDayWise.jsx";
import BusListWithLocation from "./pages/transport/BusListWithLocation.jsx";
import BusLiveLocation from "./pages/transport/BusLiveLocation.jsx";
import BatchPromote from "./pages/academicPortal/batch/BatchPromote.jsx";
import BusStudentEnrollmentEdit from "./pages/transport/BusStudentedit.jsx";
import BusStudentedit from "./pages/transport/BusStudentedit.jsx";
import StudentAttendanceManual from "./pages/attendance/StudentAttendanceManual.jsx";
import NotificationHistory from "./pages/notification/NotificationHistory.jsx";
import Notices from "./pages/Academic/Notices.jsx";
import StudentBusTransfer from "./pages/student/v5/tabs/StudentBusTransfer.jsx";
import MetaWaTemplatesCreate from "./pages/message/meta/MetaWaTemplatesCreate.jsx";
import StudentSubjectMapping from "./pages/student/v4/BulkStudentSubjectsUpdate.jsx";
import MessAttendanceMark from "./pages/mess/MessAttendanceMark.jsx";
import MessAttendanceLog from "./pages/mess/MessAttendanceLog.jsx";
import MessAttendanceMonthlySummary from "./pages/mess/MessAttendanceMonthlySummary.jsx";
import BusPass from "./pages/transport/BusPass.jsx";
import StudentAttendanceAndMessages from "./pages/attendance/StudentAttendanceAndMessages.jsx";
import DistributionKitList from "./pages/DistributionKit/DistributionKitList.jsx";
import DistributionKitItems from "./pages/DistributionKit/DistributionKitItems.jsx";
import DistributionReport from "./pages/DistributionKit/DistributionReport.jsx";
import DistributionKitPayment from "./pages/DistributionKit/DistributionKitPayment.jsx";
import DistributionKitPaymentReceipt from "./pages/DistributionKit/DistributionKitPaymentReceipt.jsx";
import SendNotification from "./pages/notification/SendPushNotification.jsx";
import StudentProfilePictureImport from "./pages/studentImport/v1/StudentProfilePictureImport.jsx";
import StudentAttendanceDashboardv2 from "./pages/attendance/reports/dashbaord.jsx";
import DayOverviewReport from "./pages/attendance/reports/DayOverviewReport.jsx";
import MonthlyAttendanceRegister from "./pages/attendance/reports/MonthlyAttendanceRegister.jsx";
import StudentAttendancesAnnualv2 from "./pages/attendance/reports/StudentAttendancesAnnualv2.jsx";
import StudentAttendanceManualv2 from "./pages/attendance/reports/StudentAttendanceManualv2.jsx";
import StudentAttendanceAndMessagesReport from "./pages/attendance/reports/StudentAttendanceAndMessages.jsx";
import StudentLowAttendanceReportv2 from "./pages/attendance/reports/StudentLowAttendanceReport.jsx";
import StudentAttendanceFullReport from "./pages/attendance/reports/StudentAttendanceFullReport.jsx";
import PaymentTransactionHistory from "./pages/studentFeeReport/PaymentTransactionHistory.jsx";
import AdmissionMonthWiseAttendanceReport from "./pages/attendance/reports/AdmissionMonthWiseAttendanceReport.jsx";
import TestSyllabus from "./pages/main/testsList/TestSyllabus.jsx";
import FamilyFeeDeposit from "./pages/fees/FamilyFeeDeposit.jsx";
import BankTransactionList from "./pages/main/Settings/BankTransactions.jsx";
import Index4 from "./pages/Index4.jsx";
import BusFeeUpdate from "./pages/student/v4/BusFeeUpdate.jsx";
import StudentStudyCertificate from "./pages/idCards/StudentStudyCertificate.jsx";
import StudentAssignmentStatus from "./pages/Assignments/StudentAssignmentStatus.jsx";
import StaffAccessManagement from "./pages/staffs/StaffAccessManagement.jsx";
import MarketingStudentExcelImport from "./pages/main/Marketings/MarketingStudentExcelImport.jsx";

function App() {
  const initialTheme = localStorage.getItem("myTheme") === "true";

  useEffect(() => {
    const coreCss = document.querySelector(".template-customizer-core-css");
    const themeCss = document.querySelector(".template-customizer-theme-css");

    if (initialTheme) {
      document.documentElement.setAttribute("data-style", "dark");
      if (coreCss && themeCss) {
        coreCss.setAttribute("href", "/assets/vendor/css/rtl/core-dark.css");
        themeCss.setAttribute(
          "href",
          "/assets/vendor/css/rtl/theme-default-dark.css",
        );
      }
    } else {
      document.documentElement.setAttribute("data-style", "light");
      if (coreCss && themeCss) {
        coreCss.setAttribute("href", "/assets/vendor/css/rtl/core.css");
        themeCss.setAttribute(
          "href",
          "/assets/vendor/css/rtl/theme-default.css",
        );
      }
    }
  }, [initialTheme]);

  useOpenFilterCanvasShortcut("filterCanvas", {
    key: "f",
    meta: true,
    shift: true,
  });

  useEffect(() => {
    const cleanup = initGlobalInputFormatter();

    return () => {
      cleanup();
    };
  }, []);

  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        <Route
          path="/admin/dashboard"
          element={
            <PrivateRoute>
              <AdminDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/student/report"
          element={
            <PrivateRoute>
              <AdminStudentReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/branch/list"
          element={
            <PrivateRoute>
              <AdminBranchList />
            </PrivateRoute>
          }
        />
        <Route
          path="/branch/add"
          element={
            <PrivateRoute>
              <BranchAdd />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/finance/report"
          element={
            <PrivateRoute>
              <FinanceReport />
            </PrivateRoute>
          }
        />

        <Route path="/user/verify" element={<ClientVerify />} />
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/apps-links" element={<AppDownload />} />
        <Route path="/user/help" element={<Help />} />
        <Route path="/issue/list" element={<IssueList />} />

        <Route
          path="/meta/wa_send_msg"
          element={
            <PrivateRoute>
              <MetaWaSendMsg />
            </PrivateRoute>
          }
        />
        <Route
          path="/meta/templates"
          element={
            <PrivateRoute>
              <MetaWaTemplates />
            </PrivateRoute>
          }
        />
        <Route
          path="/meta/templates/create"
          element={
            <PrivateRoute>
              <MetaWaTemplatesCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="/meta/history"
          element={
            <PrivateRoute>
              <MetaWaHistory />
            </PrivateRoute>
          }
        />
        <Route
          path="/meta/wallet"
          element={
            <PrivateRoute>
              <MetaWaWallet />
            </PrivateRoute>
          }
        />

        <Route
          path="/message/list"
          element={
            <PrivateRoute>
              <MessagesList />
            </PrivateRoute>
          }
        />
        <Route
          path="/message/add"
          element={
            <PrivateRoute>
              <MessagesAdd />
            </PrivateRoute>
          }
        />
        <Route
          path="/message/update"
          element={
            <PrivateRoute>
              <MessagesUpdate />
            </PrivateRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings/addition/details"
          element={
            <PrivateRoute>
              <AdditionDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/app/configuration"
          element={
            <PrivateRoute>
              <AppConfiguration />
            </PrivateRoute>
          }
        />

        <Route
          path="/sessions"
          element={
            <PrivateRoute>
              <Sessions />
            </PrivateRoute>
          }
        />
        <Route
          path="/subjects"
          element={
            <PrivateRoute>
              <Subjects />
            </PrivateRoute>
          }
        />

        <Route
          path="/courses"
          element={
            <PrivateRoute>
              <Courses />
            </PrivateRoute>
          }
        />
        <Route
          path="/course/add"
          element={
            <PrivateRoute>
              <CourseAdd />
            </PrivateRoute>
          }
        />
        <Route
          path="/course/update"
          element={
            <PrivateRoute>
              <CourseUpdate />
            </PrivateRoute>
          }
        />

        <Route
          path="/batches"
          element={
            <PrivateRoute>
              <Batches />
            </PrivateRoute>
          }
        />
        <Route
          path="/batch/add"
          element={
            <PrivateRoute>
              <BatchAdd />
            </PrivateRoute>
          }
        />
        <Route
          path="/batch/update"
          element={
            <PrivateRoute>
              <BatchUpdate />
            </PrivateRoute>
          }
        />
        <Route
          path="/batch/detail"
          element={
            <PrivateRoute>
              <BatchDetail />
            </PrivateRoute>
          }
        />

        <Route
          path="/discount/offers/list"
          element={
            <PrivateRoute>
              <DiscountOffersList />
            </PrivateRoute>
          }
        />
        <Route
          path="/discount/offers/add"
          element={
            <PrivateRoute>
              <DiscountOfferAdd />
            </PrivateRoute>
          }
        />
        <Route
          path="/discount/offers/update"
          element={
            <PrivateRoute>
              <DiscountOfferUpdate />
            </PrivateRoute>
          }
        />

        <Route
          path="/role"
          element={
            <PrivateRoute>
              <Role />
            </PrivateRoute>
          }
        />
        <Route
          path="/role/add"
          element={
            <PrivateRoute>
              <RoleAdd />
            </PrivateRoute>
          }
        />
        <Route
          path="/role/update"
          element={
            <PrivateRoute>
              <RoleUpdate />
            </PrivateRoute>
          }
        />
        <Route
          path="/role/view"
          element={
            <PrivateRoute>
              <RoleView />
            </PrivateRoute>
          }
        />

        <Route
          path="/enquiry"
          element={
            <PrivateRoute>
              <Enquiries />
            </PrivateRoute>
          }
        />
        <Route
          path="/enquiry/add"
          element={
            <PrivateRoute>
              <EnquiryAdd />
            </PrivateRoute>
          }
        />
        <Route
          path="/enquiry/update"
          element={
            <PrivateRoute>
              <EnquiryUpdate />
            </PrivateRoute>
          }
        />
        <Route
          path="/enquiry/detail"
          element={
            <PrivateRoute>
              <EnquiryDetail />
            </PrivateRoute>
          }
        />

        <Route
          path="/enquiry/followups"
          element={
            <PrivateRoute>
              <EnquiryFollowups />
            </PrivateRoute>
          }
        />
        <Route
          path="/enquiry/form/print"
          element={
            <PrivateRoute>
              <EnquiryFormPrint />
            </PrivateRoute>
          }
        />
        <Route
          path="/enquiry/demo/form/print"
          element={
            <PrivateRoute>
              <EnquiryDemoFormPrint />
            </PrivateRoute>
          }
        />
        <Route
          path="/enquiry/reports"
          element={
            <PrivateRoute>
              <EnquiryReports />
            </PrivateRoute>
          }
        />

        <Route
          path="/transport/report"
          element={
            <PrivateRoute>
              <TransportReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/bus/list"
          element={
            <PrivateRoute>
              <BusList />
            </PrivateRoute>
          }
        />
        <Route
          path="/roots/stops/list"
          element={
            <PrivateRoute>
              <BusRouteStopList />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/bus/enroll"
          element={
            <PrivateRoute>
              <StudentBusEnroll />
            </PrivateRoute>
          }
        />
        <Route
          path="/bus/student/list"
          element={
            <PrivateRoute>
              <BusStudentList />
            </PrivateRoute>
          }
        />
        <Route
          path="/bus/stop/import"
          element={
            <PrivateRoute>
              <BusStopImport />
            </PrivateRoute>
          }
        />
        <Route
          path="/bus/student/import"
          element={
            <PrivateRoute>
              <BusStudentImport />
            </PrivateRoute>
          }
        />

        <Route
          path="/student/bus/enrollment/edit"
          element={
            <PrivateRoute>
              <BusStudentedit />
            </PrivateRoute>
          }
        />

        <Route
          path="/bus/pass"
          element={
            <PrivateRoute>
              <BusPass />
            </PrivateRoute>
          }
        />

        <Route
          path="/students/import"
          element={
            <PrivateRoute>
              <StudentsImportV5 />
            </PrivateRoute>
          }
        />
        <Route
          path="/students/update/fee"
          element={
            <PrivateRoute>
              <StudentFeeUpdateV1 />
            </PrivateRoute>
          }
        />
        <Route
          path="/bulk/student/subjects/update"
          element={
            <PrivateRoute>
              <StudentSubjectMapping />
            </PrivateRoute>
          }
        />
        <Route
          path="/students/import/v1"
          element={
            <PrivateRoute>
              <StudentsOnlyV1 />
            </PrivateRoute>
          }
        />
        <Route
          path="/students/import/batch-enroll/v1"
          element={
            <PrivateRoute>
              <StudentsBatchEnrollV1 />
            </PrivateRoute>
          }
        />
        <Route
          path="/students/discount/offer/set"
          element={
            <PrivateRoute>
              <StudentDiscountOfferApply />
            </PrivateRoute>
          }
        />

        <Route
          path="/students"
          element={
            <PrivateRoute>
              <Students />
            </PrivateRoute>
          }
        />
        <Route
          path="/duplicate/students"
          element={
            <PrivateRoute>
              <StudentsDuplicate />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/admission/form/print"
          element={
            <PrivateRoute>
              <StudentAdmissionFormPrint />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/demo/form/print"
          element={
            <PrivateRoute>
              <StudentDemoFormPrint />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/add"
          element={
            <PrivateRoute>
              <StudentAdd />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/details/v2"
          element={
            <PrivateRoute>
              <StudentV2Details />
            </PrivateRoute>
          }
        />

        <Route
          path="/student/details/v4"
          element={
            <PrivateRoute>
              <StudentDetailsV4 />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/details"
          element={
            <PrivateRoute>
              <StudentDetailsV5 />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/batch/enroll"
          element={
            <PrivateRoute>
              <StudentEnrollBatchV4 />
            </PrivateRoute>
          }
        />

        <Route
          path="/student/batch/enroll/v2"
          element={
            <PrivateRoute>
              <StudentEnrollBatch />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/bus/enroll/v0"
          element={
            <PrivateRoute>
              <StudentEnrollBus />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/update"
          element={
            <PrivateRoute>
              <StudentUpdate />
            </PrivateRoute>
          }
        />

        <Route
          path="/student/subjects/Fee/Up"
          element={
            <PrivateRoute>
              <StudentSubjectsAndFeeUp />
            </PrivateRoute>
          }
        />

        <Route
          path="/student/app/login/status"
          element={
            <PrivateRoute>
              <StudentLoginStatus />
            </PrivateRoute>
          }
        />
        <Route
          path="/students/report/v4"
          element={
            <PrivateRoute>
              <StudentsReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/students/report"
          element={
            <PrivateRoute>
              <StudentReportV4 />
            </PrivateRoute>
          }
        />
        <Route
          path="/students/rte"
          element={
            <PrivateRoute>
              <RTEStudentList />
            </PrivateRoute>
          }
        />
        <Route
          path="/rte/transactions"
          element={
            <PrivateRoute>
              <RTETransaction />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/v2/details"
          element={
            <PrivateRoute>
              <StudentDetails />
            </PrivateRoute>
          }
        />

        <Route
          path="/basic/v2/details"
          element={
            <PrivateRoute>
              <BasicV2Details />
            </PrivateRoute>
          }
        />
        <Route
          path="/course/v2/details"
          element={
            <PrivateRoute>
              <CourseNFees />
            </PrivateRoute>
          }
        />

        <Route
          path="/student/form"
          element={
            <PrivateRoute>
              <StudentFrom />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/demo"
          element={
            <PrivateRoute>
              <StudentDemo />
            </PrivateRoute>
          }
        />
        <Route path="/student/bus/id-card" element={<BusStudentIdCardPage />} />
        <Route
          path="/student/id-card"
          element={
            <PrivateRoute>
              <StudentIdCard />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/character-certificate"
          element={
            <PrivateRoute>
              <StudentCharacterCertificate />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/transfer-certificate"
          element={
            <PrivateRoute>
              <StudentTransferCertificate />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/marksheet"
          element={
            <PrivateRoute>
              <StudentMarksheet />
            </PrivateRoute>
          }
        />
        <Route
          path="/student-reviews"
          element={
            <PrivateRoute>
              <StudentsReviews />
            </PrivateRoute>
          }
        />

        <Route
          path="/student/fees/deposit/v2"
          element={
            <PrivateRoute>
              <StudentFeeDeposit />
            </PrivateRoute>
          }
        />

        <Route
          path="/student/fees/deposit"
          element={
            <PrivateRoute>
              <StudentFeeDepositV4 />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/manual/fee/deposit"
          element={
            <PrivateRoute>
              <StudentManualFeeDeposit />
            </PrivateRoute>
          }
        />

        <Route
          path="/family/fees/deposit"
          element={
            <PrivateRoute>
              <FamilyFeeDeposit />
            </PrivateRoute>
          }
        />

        <Route
          path="/student/fees/receipt"
          element={
            <PrivateRoute>
              <StudentFeeReceipt />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/batch/transfer"
          element={
            <PrivateRoute>
              <StudentBatchTransfer />
            </PrivateRoute>
          }
        />

        <Route
          path="/bus/student/attendance/list"
          element={
            <PrivateRoute>
              <BusStudentAttendanceList />
            </PrivateRoute>
          }
        />

        <Route
          path="/student/attendance/dashboard"
          element={
            <PrivateRoute>
              <StudentAttendanceDashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/student/attendance/dashboard/v2"
          element={
            <PrivateRoute>
              <StudentAttendanceDashboardv2 />
            </PrivateRoute>
          }
        />
        <Route
          path="/attendance/reports/day-wise"
          element={
            <PrivateRoute>
              <DayOverviewReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/attendance/reports/monthly"
          element={
            <PrivateRoute>
              <MonthlyAttendanceRegister />
            </PrivateRoute>
          }
        />
        <Route
          path="/attendance/reports/admission-month-wise"
          element={
            <PrivateRoute>
              <AdmissionMonthWiseAttendanceReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/attendance/reports/annual"
          element={
            <PrivateRoute>
              <StudentAttendancesAnnualv2 />
            </PrivateRoute>
          }
        />
        <Route
          path="/attendance/mark"
          element={
            <PrivateRoute>
              <StudentAttendanceManualv2 />
            </PrivateRoute>
          }
        />
        <Route
          path="/attendance/reports/message-delivery"
          element={
            <PrivateRoute>
              <StudentAttendanceAndMessagesReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/attendance/reports/low-attendance"
          element={
            <PrivateRoute>
              <StudentLowAttendanceReportv2 />
            </PrivateRoute>
          }
        />

        <Route
          path="/student/attendance/followups"
          element={
            <PrivateRoute>
              <StudentAttendanceFollowups />
            </PrivateRoute>
          }
        />

        <Route
          path="/student-attendance/student/:studentId/report"
          element={
            <PrivateRoute>
              <StudentAttendanceFullReport />
            </PrivateRoute>
          }
        />

        {/* 12 */}
        {/* <Route
          path="/student/attendance/list"
          element={
            <PrivateRoute>
              <StudentAttendances />
            </PrivateRoute>
          }
        /> */}
        <Route
          path="/student/attendance/list"
          element={
            <PrivateRoute>
              <StudentAttendanceAndMessages />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/attendance/messages/list"
          element={
            <PrivateRoute>
              <StudentAttendanceAndMessages />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/attendance/manual"
          element={
            <PrivateRoute>
              <StudentAttendanceManual />
            </PrivateRoute>
          }
        />

        <Route
          path="/student/attendance/list/monthly"
          element={
            <PrivateRoute>
              <StudentAttendancesMonthly />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/attendance/list/annual"
          element={
            <PrivateRoute>
              <StudentAttendancesAnnual />
            </PrivateRoute>
          }
        />
        <Route
          path="/staff/attendance/dashboard"
          element={
            <PrivateRoute>
              <StaffAttendanceDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/staff/attendance/list"
          element={
            <PrivateRoute>
              <StaffAttendances />
            </PrivateRoute>
          }
        />
        <Route
          path="/staff/attendance/list/monthly"
          element={
            <PrivateRoute>
              <StaffAttendancesMonthly />
            </PrivateRoute>
          }
        />
        <Route
          path="/holidays"
          element={
            <PrivateRoute>
              <Holidays />
            </PrivateRoute>
          }
        />
        <Route
          path="/holidays/add"
          element={
            <PrivateRoute>
              <HolidaysAdd />
            </PrivateRoute>
          }
        />
        <Route
          path="/holidays/update"
          element={
            <PrivateRoute>
              <HolidaysUpdate />
            </PrivateRoute>
          }
        />
        <Route
          path="/leave/request"
          element={
            <PrivateRoute>
              <LeaveRequest />
            </PrivateRoute>
          }
        />

        <Route
          path="/essl/devices/list"
          element={
            <PrivateRoute>
              <DevicesList />
            </PrivateRoute>
          }
        />
        <Route
          path="/essl/devices/logs"
          element={
            <PrivateRoute>
              <DevicesLogs />
            </PrivateRoute>
          }
        />

        <Route
          path="/essl/devices/students"
          element={
            <PrivateRoute>
              <EsslRegisteredUsers />
            </PrivateRoute>
          }
        />

        <Route
          path="/documents/type"
          element={
            <PrivateRoute>
              <DocumentsType />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/documents"
          element={
            <PrivateRoute>
              <StudentDocuments />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/documents/add"
          element={
            <PrivateRoute>
              <StudentDocumentsAdd />
            </PrivateRoute>
          }
        />

        <Route
          path="/DistributionEntry"
          element={
            <PrivateRoute>
              <DistributionEntry />
            </PrivateRoute>
          }
        />
        <Route
          path="/collections/distribution/items"
          element={
            <PrivateRoute>
              <Items />
            </PrivateRoute>
          }
        />
        <Route
          path="/collections/distribution/item/fields"
          element={
            <PrivateRoute>
              <ItemFields />
            </PrivateRoute>
          }
        />

        <Route
          path="/collection/update"
          element={
            <PrivateRoute>
              <CollectionUpdate />
            </PrivateRoute>
          }
        />

        <Route
          path="/hostel/list"
          element={
            <PrivateRoute>
              <HostelMain />
            </PrivateRoute>
          }
        />

        <Route
          path="/hostel"
          element={
            <PrivateRoute>
              <HostelDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/students"
          element={
            <PrivateRoute>
              <HostelStudents />
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/student/add"
          element={
            <PrivateRoute>
              <HostelStudentAdd />
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/fees/deposit"
          element={
            <PrivateRoute>
              <HostelFeesDeposit />
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/fees/pay"
          element={
            <PrivateRoute>
              <HostelFeesPay />
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/fee_receipt"
          element={
            <PrivateRoute>
              <HostelFeeReceipt />
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/rooms"
          element={
            <PrivateRoute>
              <HostelRooms />
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/hostels"
          element={
            <PrivateRoute>
              <Hostels />
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/reports"
          element={
            <PrivateRoute>
              <HostelReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/expense/category"
          element={
            <PrivateRoute>
              <HostelExpenseCategory />
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/expenses"
          element={
            <PrivateRoute>
              <HostelExpenses />
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/student/id-card"
          element={
            <PrivateRoute>
              <HostelStudentIdCard />
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/student/transfer"
          element={
            <PrivateRoute>
              <HostelStudentTransfer />
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/student/attendance"
          element={
            <PrivateRoute>
              <HostelStudentAttendance />
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/student/attendance/list"
          element={
            <PrivateRoute>
              <HostelStudentAttendanceList />
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/student/attendance/list/monthly"
          element={
            <PrivateRoute>
              <HostelStudentAttendanceListMonthly />
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/profile"
          element={
            <PrivateRoute>
              <HostelProfile />
            </PrivateRoute>
          }
        />

        <Route
          path="/mess/list"
          element={
            <PrivateRoute>
              <Mess />
            </PrivateRoute>
          }
        />
        <Route
          path="/mess/enroll/list"
          element={
            <PrivateRoute>
              <MessEnrollList />
            </PrivateRoute>
          }
        />
        <Route
          path="/mess/enroll"
          element={
            <PrivateRoute>
              <MessEnroll />
            </PrivateRoute>
          }
        />
        <Route
          path="/mess/attendance/list"
          element={
            <PrivateRoute>
              <MessAttendanceList />
            </PrivateRoute>
          }
        />
        <Route
          path="/mess/attendance/mark"
          element={
            <PrivateRoute>
              <MessAttendanceMark />
            </PrivateRoute>
          }
        />
        <Route
          path="/mess/attendance/log"
          element={
            <PrivateRoute>
              <MessAttendanceLog />
            </PrivateRoute>
          }
        />
        <Route
          path="/mess/attendance/summary"
          element={
            <PrivateRoute>
              <MessAttendanceMonthlySummary />
            </PrivateRoute>
          }
        />
        <Route
          path="/mess/guest/card"
          element={
            <PrivateRoute>
              <MessGuestCard />
            </PrivateRoute>
          }
        />
        <Route
          path="/library/dashboard"
          element={
            <PrivateRoute>
              <LibraryDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/libraries"
          element={
            <PrivateRoute>
              <Libraries />
            </PrivateRoute>
          }
        />
        <Route
          path="/library/shifts"
          element={
            <PrivateRoute>
              <LibraryShifts />
            </PrivateRoute>
          }
        />
        <Route
          path="/library/seats"
          element={
            <PrivateRoute>
              <LibrarySeats />
            </PrivateRoute>
          }
        />
        <Route
          path="/library/students"
          element={
            <PrivateRoute>
              <LibraryStudents />
            </PrivateRoute>
          }
        />
        <Route
          path="/library/student/add"
          element={
            <PrivateRoute>
              <LibraryStudentAdd />
            </PrivateRoute>
          }
        />
        <Route
          path="/library/student/profile"
          element={
            <PrivateRoute>
              <LibraryStudentProfile />
            </PrivateRoute>
          }
        />
        <Route
          path="/library/student/id-card"
          element={
            <PrivateRoute>
              <HostelStudentIdCard />
            </PrivateRoute>
          }
        />
        <Route
          path="/library/fees"
          element={
            <PrivateRoute>
              <LibraryFees />
            </PrivateRoute>
          }
        />
        <Route
          path="/library/dues"
          element={
            <PrivateRoute>
              <LibraryDues />
            </PrivateRoute>
          }
        />
        <Route
          path="/library/fees/deposit"
          element={
            <PrivateRoute>
              <HostelFeesDeposit />
            </PrivateRoute>
          }
        />
        <Route
          path="/library/fees/pay"
          element={
            <PrivateRoute>
              <HostelFeesPay />
            </PrivateRoute>
          }
        />
        <Route
          path="/library/fee_receipt"
          element={
            <PrivateRoute>
              <HostelFeeReceipt />
            </PrivateRoute>
          }
        />
        <Route
          path="/library/reports"
          element={
            <PrivateRoute>
              <HostelReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/library/expense/category"
          element={
            <PrivateRoute>
              <HostelExpenseCategory />
            </PrivateRoute>
          }
        />
        <Route
          path="/library/expenses"
          element={
            <PrivateRoute>
              <HostelExpenses />
            </PrivateRoute>
          }
        />

        <Route
          path="/attendance"
          element={
            <PrivateRoute>
              <Attendance />
            </PrivateRoute>
          }
        />
        <Route
          path="/report/fee/transactions"
          element={
            <PrivateRoute>
              <FeeTransactions />
            </PrivateRoute>
          }
        />

        {/* --------------------------------------------------------------------------------------------------- */}

        <Route
          path="/idcard"
          element={
            <PrivateRoute>
              <IdCardV3 />
            </PrivateRoute>
          }
        />
        <Route path="/reporting/dashboard" element={<Index3 />} />
        <Route path="/" element={<Index4 />} />

        <Route
          path="/documents/collection"
          element={
            <PrivateRoute>
              <DocumentCollection />
            </PrivateRoute>
          }
        />
        <Route
          path="/marksheet/report"
          element={
            <PrivateRoute>
              <MarksheetReport />
            </PrivateRoute>
          }
        />

        <Route
          path="/students/all"
          element={
            <PrivateRoute>
              <StudentsList />
            </PrivateRoute>
          }
        />

        <Route
          path="/documents/category"
          element={
            <PrivateRoute>
              <DocumentCategory />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings/users"
          element={
            <PrivateRoute>
              <UsersPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/settings/application"
          element={
            <PrivateRoute>
              <Application />
            </PrivateRoute>
          }
        />

        <Route
          path="/settings/banner"
          element={
            <PrivateRoute>
              <Banner />
            </PrivateRoute>
          }
        />

        <Route
          path="/syllabus"
          element={
            <PrivateRoute>
              <SyllabusView />
            </PrivateRoute>
          }
        />
        <Route
          path="/syllabus/add"
          element={
            <PrivateRoute>
              <SyllabusManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/syllabus/update"
          element={
            <PrivateRoute>
              <SyllabusUpdate />
            </PrivateRoute>
          }
        />
        <Route
          path="/syllabus/assign"
          element={
            <PrivateRoute>
              <SyllabusAssign />
            </PrivateRoute>
          }
        />
        <Route
          path="/syllabus/assign/add"
          element={
            <PrivateRoute>
              <SyllabusAssignForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/syllabus/assign/update"
          element={
            <PrivateRoute>
              <SyllabusAssignUpdate />
            </PrivateRoute>
          }
        />

        <Route path="/idcard3" element={<IdCard3 />} />
        <Route
          path="/cleander"
          element={
            <PrivateRoute>
              <Cleander />
            </PrivateRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <PrivateRoute>
              <Reports2 />
            </PrivateRoute>
          }
        />

        <Route
          path="/reports/fee/report"
          element={
            <PrivateRoute>
              <FeeReport />
            </PrivateRoute>
          }
        />

        <Route
          path="/reports/fee/due"
          element={
            <PrivateRoute>
              <FeeDue />
            </PrivateRoute>
          }
        />

        <Route
          path="/reports/credit/debit"
          element={
            <PrivateRoute>
              <CreditDebit />
            </PrivateRoute>
          }
        />

        <Route
          path="/reports/expense/report"
          element={
            <PrivateRoute>
              <ExpenseReport />
            </PrivateRoute>
          }
        />

        <Route
          path="/reports/staff/report"
          element={
            <PrivateRoute>
              <StaffReport />
            </PrivateRoute>
          }
        />

        <Route
          path="/alert"
          element={
            <PrivateRoute>
              <Alert />
            </PrivateRoute>
          }
        />

        <Route
          path="/settings/bank"
          element={
            <PrivateRoute>
              <BankAccount />
            </PrivateRoute>
          }
        />

        <Route
          path="/settings/bank/fund/transfer"
          element={
            <PrivateRoute>
              <BankFundTransfer />
            </PrivateRoute>
          }
        />

        <Route
          path="/experience/certificate"
          element={
            <PrivateRoute>
              <ExperienceCertificate />
            </PrivateRoute>
          }
        />
        <Route
          path="/character/certificate"
          element={
            <PrivateRoute>
              <CCCertificate />
            </PrivateRoute>
          }
        />

        <Route
          path="/notice/board"
          element={
            <PrivateRoute>
              <Notices />
            </PrivateRoute>
          }
        />
        <Route
          path="/work/report/list"
          element={
            <PrivateRoute>
              <StaffWorkReports />
            </PrivateRoute>
          }
        />

        <Route
          path="/holiday"
          element={
            <PrivateRoute>
              <Holiday />
            </PrivateRoute>
          }
        />

        <Route
          path="/home/work"
          element={
            <PrivateRoute>
              <HomeWork />
            </PrivateRoute>
          }
        />

        <Route
          path="/photo/gallery"
          element={
            <PrivateRoute>
              <Gallery />
            </PrivateRoute>
          }
        />

        <Route
          path="/followup_response"
          element={
            <PrivateRoute>
              <FeeFollowUpResponse />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings/user_role/update"
          element={
            <PrivateRoute>
              <UpdateUserRole />
            </PrivateRoute>
          }
        />
        <Route
          path="/annual/report"
          element={
            <PrivateRoute>
              <AnnualTest />
            </PrivateRoute>
          }
        />
        <Route
          path="/annual/report/table"
          element={
            <PrivateRoute>
              <AnnualTable />
            </PrivateRoute>
          }
        />

        <Route
          path="/marksheet/sample"
          element={
            <PrivateRoute>
              <MarksheetSample />
            </PrivateRoute>
          }
        />
        <Route
          path="/batch-promote"
          element={
            <PrivateRoute>
              <BatchPromote />
            </PrivateRoute>
          }
        />
        <Route
          path="/bus"
          element={
            <PrivateRoute>
              <Bus />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/bus/transfer"
          element={
            <PrivateRoute>
              <StudentBusTransfer />
            </PrivateRoute>
          }
        />

        <Route
          path="/admit/student/bus"
          element={
            <PrivateRoute>
              <AdmitStudentBus />
            </PrivateRoute>
          }
        />

        <Route
          path="/bus/routes"
          element={
            <PrivateRoute>
              <BusRoutes />
            </PrivateRoute>
          }
        />
        <Route
          path="/bus/students"
          element={
            <PrivateRoute>
              <BusStudents />
            </PrivateRoute>
          }
        />

        <Route
          path="/merit/students"
          element={
            <PrivateRoute>
              <MeritStudent />
            </PrivateRoute>
          }
        />

        <Route
          path="/NewForm"
          element={
            <PrivateRoute>
              <NewForm />
            </PrivateRoute>
          }
        />

        <Route
          path="/student/profile"
          element={
            <PrivateRoute>
              <StudentProfile2 />
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/profile"
          element={
            <PrivateRoute>
              <HostelProfile />
            </PrivateRoute>
          }
        />

        <Route
          path="/hostel/banks"
          element={
            <PrivateRoute>
              <HostelBankAccount />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/banks/fund/transfer"
          element={
            <PrivateRoute>
              <HostelFundTransfer />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/expense/report"
          element={
            <PrivateRoute>
              <HostelExpenseReport />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/fee/report"
          element={
            <PrivateRoute>
              <HostelFeeReport />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/fee/due/report"
          element={
            <PrivateRoute>
              <HostelFeeDue />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/student/month/report"
          element={
            <PrivateRoute>
              <HostelMonthlyReport />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/hostel/credit/debit/report"
          element={
            <PrivateRoute>
              <HotelCreditDebit />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/student/course_fee"
          element={
            <PrivateRoute>
              <CourseFeeInfo />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/fees/collection/v2"
          element={
            <PrivateRoute>
              <FeeCollection />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/fees/collection"
          element={
            <PrivateRoute>
              <FeeCollectionV4 />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/fees/collection/v4"
          element={
            <PrivateRoute>
              <FeeCollectionV2 />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/fees/followup/v2"
          element={
            <PrivateRoute>
              <FeeFollowupV2 />{" "}
            </PrivateRoute>
          }
        />

        <Route
          path="/fees/report"
          element={
            <PrivateRoute>
              <FeesReport />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/fees/mismatch/report"
          element={
            <PrivateRoute>
              <StudentFeeMismatchReport />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/fees/transactions"
          element={
            <PrivateRoute>
              <FeesTransactions />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/fees/transactions/v2"
          element={
            <PrivateRoute>
              <FeesTransactionsV2 />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/all/fees/transactions"
          element={
            <PrivateRoute>
              <AllFeesTransactions />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/student/due/fee"
          element={
            <PrivateRoute>
              <StudentFeeDueReport />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/all/student/fee/report"
          element={
            <PrivateRoute>
              <StudentFeeReport />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/student/due/fee/type-wise"
          element={
            <PrivateRoute>
              <StudentFeeDueTypeWise />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/batch/fee/report"
          element={
            <PrivateRoute>
              <BatchDueFeesReport />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/batch/fee/report/all/students"
          element={
            <PrivateRoute>
              <BatchDueFeesReportAllStudents />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/batch/fee/edit"
          element={
            <PrivateRoute>
              <BatchFeesEdit />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/fee/discount/report"
          element={
            <PrivateRoute>
              <StudentFeeDiscountReport />{" "}
            </PrivateRoute>
          }
        />

        <Route
          path="/fees/report/dashboard"
          element={
            <PrivateRoute>
              <FeesReportDashboard />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/student/due/fees"
          element={
            <PrivateRoute>
              <StudentDueFees />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/student/due/fees/v4"
          element={
            <PrivateRoute>
              <StudentDueFees />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path="/student/due/registration"
          element={
            <PrivateRoute>
              <StudentDueRegistration />{" "}
            </PrivateRoute>
          }
        />

        <Route
          path="/fees/collection/followUp"
          element={
            <PrivateRoute>
              <FeeCollectionFollowup />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings/user/add_new_role"
          element={
            <PrivateRoute>
              <UserNewRole />
            </PrivateRoute>
          }
        />

        <Route
          path="/documents/add"
          element={
            <PrivateRoute>
              <AddDocument />
            </PrivateRoute>
          }
        />
        <Route
          path="/documents/distribution"
          element={
            <PrivateRoute>
              <DocumentsDistribution />
            </PrivateRoute>
          }
        />
        <Route
          path="/documents/addistribution"
          element={
            <PrivateRoute>
              <Distributedlist />
            </PrivateRoute>
          }
        />

        <Route
          path="/students/fee-receipt"
          element={
            <PrivateRoute>
              <FeeReceipt />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/marks_report"
          element={
            <PrivateRoute>
              <TestResultsTable />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/kit_report"
          element={
            <PrivateRoute>
              <KitsDetailsTable />
            </PrivateRoute>
          }
        />

        <Route
          path="/attendance/biometric"
          element={
            <PrivateRoute>
              <BioMetricData />
            </PrivateRoute>
          }
        />
        <Route
          path="/attendance/biometricdevice"
          element={
            <PrivateRoute>
              <BioMetricDevice />
            </PrivateRoute>
          }
        />

        <Route
          path="/attendance_month"
          element={
            <PrivateRoute>
              <Attendancemonth />
            </PrivateRoute>
          }
        />
        <Route
          path="/staff_attendance"
          element={
            <PrivateRoute>
              <StaffAttendance />
            </PrivateRoute>
          }
        />
        <Route
          path="/demo_student"
          element={
            <PrivateRoute>
              <DemoSstudent />
            </PrivateRoute>
          }
        />
        <Route
          path="/demo_month_student"
          element={
            <PrivateRoute>
              <DemoMonthAttendance />
            </PrivateRoute>
          }
        />
        <Route
          path="/staff_month_attendance"
          element={
            <PrivateRoute>
              <StaffMonthAttendance />
            </PrivateRoute>
          }
        />
        <Route
          path="/allocate"
          element={
            <PrivateRoute>
              <AlocateData />
            </PrivateRoute>
          }
        />
        <Route
          path="/teachers"
          element={
            <PrivateRoute>
              <Teachers />
            </PrivateRoute>
          }
        />
        <Route
          path="/teachers/view/:id"
          element={
            <PrivateRoute>
              <Teacherview2 />
            </PrivateRoute>
          }
        />
        <Route
          path="/teachers/add"
          element={
            <PrivateRoute>
              <AddStaff />
            </PrivateRoute>
          }
        />

        <Route
          path="/teacher/working/schedule"
          element={
            <PrivateRoute>
              <WorkingSchedule />
            </PrivateRoute>
          }
        />
        <Route
          path="/EditStaff/:id"
          element={
            <PrivateRoute>
              <EditStaff />
            </PrivateRoute>
          }
        />
        <Route
          path="/teachers/update"
          element={
            <PrivateRoute>
              <UpdateStaffForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/staff/salary/pay"
          element={
            <PrivateRoute>
              <StaffSalaryPay />
            </PrivateRoute>
          }
        />

        <Route
          path="/staff/report/dashboard"
          element={
            <PrivateRoute>
              <StaffReportDashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/tests"
          element={
            <PrivateRoute>
              <Testlist />
            </PrivateRoute>
          }
        />
        <Route
          path="/tests/view"
          element={
            <PrivateRoute>
              <Testsview />
            </PrivateRoute>
          }
        />
        <Route
          path="/tests/report"
          element={
            <PrivateRoute>
              <Testreport />
            </PrivateRoute>
          }
        />
        <Route
          path="/tests/add_test"
          element={
            <PrivateRoute>
              <AddNewTest />
            </PrivateRoute>
          }
        />
        <Route
          path="/tests/update_test"
          element={
            <PrivateRoute>
              <UpdateTest />
            </PrivateRoute>
          }
        />
        <Route
          path="/progressCard"
          element={
            <PrivateRoute>
              <ProgessCard />
            </PrivateRoute>
          }
        />
        <Route
          path="/tests/excel/marks/upload"
          element={<TestExcelMarksUpload />}
        />
        <Route
          path="/bus/student"
          element={
            <PrivateRoute>
              <BusStudentview />
            </PrivateRoute>
          }
        />
        <Route
          path="/buses"
          element={
            <PrivateRoute>
              <Bus />
            </PrivateRoute>
          }
        />
        <Route
          path="/kits"
          element={
            <PrivateRoute>
              <KitManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/kits/all-batch"
          element={
            <PrivateRoute>
              <AllBatchKit />
            </PrivateRoute>
          }
        />
        <Route
          path="/kits/transaction"
          element={
            <PrivateRoute>
              <KitTransaction />
            </PrivateRoute>
          }
        />
        <Route
          path="/kits/view"
          element={
            <PrivateRoute>
              <Kitview />
            </PrivateRoute>
          }
        />

        <Route
          path="/test/grading"
          element={
            <PrivateRoute>
              <TestGrading />
            </PrivateRoute>
          }
        />

        <Route
          path="/expenses"
          element={
            <PrivateRoute>
              <Expenses />
            </PrivateRoute>
          }
        />
        <Route
          path="/expense/category"
          element={
            <PrivateRoute>
              <ExpenseCategory />
            </PrivateRoute>
          }
        />

        <Route
          path="/staffs"
          element={
            <PrivateRoute>
              <Staffs />
            </PrivateRoute>
          }
        />
        <Route
          path="/staff/access"
          element={
            <PrivateRoute>
              <StaffAccessManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/staff/setting"
          element={
            <PrivateRoute>
              <StaffSetting />
            </PrivateRoute>
          }
        />
        <Route
          path="/staff/add"
          element={
            <PrivateRoute>
              <StaffAdd />
            </PrivateRoute>
          }
        />
        <Route
          path="/salary/slip"
          element={
            <PrivateRoute>
              <SalarySlip />
            </PrivateRoute>
          }
        />
        <Route
          path="/staff/update"
          element={
            <PrivateRoute>
              <StaffUpdate />
            </PrivateRoute>
          }
        />
        <Route
          path="/schedule"
          element={
            <PrivateRoute>
              <Schedule />
            </PrivateRoute>
          }
        />
        <Route
          path="/timetable"
          element={
            <PrivateRoute>
              <Timetable />
            </PrivateRoute>
          }
        />
        <Route
          path="/timetable/manage"
          element={
            <PrivateRoute>
              <TimetableManage />
            </PrivateRoute>
          }
        />
        <Route
          path="/timetable/day/wise"
          element={
            <PrivateRoute>
              <TimetableDayWise />
            </PrivateRoute>
          }
        />

        <Route
          path="/marketing"
          element={
            <PrivateRoute>
              <Marketings />
            </PrivateRoute>
          }
        />
        <Route
          path="/marketing/all-students"
          element={
            <PrivateRoute>
              <Allstudent />
            </PrivateRoute>
          }
        />
        <Route
          path="/marketing/source/assign"
          element={
            <PrivateRoute>
              <SourceAssign />
            </PrivateRoute>
          }
        />
        <Route
          path="/marketing/followup"
          element={
            <PrivateRoute>
              <FollowUpForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/marketing/add_school"
          element={
            <PrivateRoute>
              <AddMarketingSchool />
            </PrivateRoute>
          }
        />
        <Route
          path="/marketing/update_school"
          element={
            <PrivateRoute>
              <UpdateMarketingSchool />
            </PrivateRoute>
          }
        />
        <Route
          path="/marketing/add_student"
          element={
            <PrivateRoute>
              <StudentForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/marketing/student/excel/import"
          element={
            <PrivateRoute>
              <MarketingStudentExcelImport />
            </PrivateRoute>
          }
        />

        <Route
          path="/marketing/add_student/source"
          element={
            <PrivateRoute>
              <StudentCreateSource />
            </PrivateRoute>
          }
        />
        <Route
          path="/marketing/update_student"
          element={
            <PrivateRoute>
              <UpdateMarketingStudent />
            </PrivateRoute>
          }
        />

        <Route
          path="/collections/report"
          element={
            <PrivateRoute>
              <CollectionReports />
            </PrivateRoute>
          }
        />

        <Route
          path="/idcard/student"
          element={
            <PrivateRoute>
              <ProfileUpdate />
            </PrivateRoute>
          }
        />
        <Route
          path="/idcard_staff"
          element={
            <PrivateRoute>
              <IdCardV3Staff />
            </PrivateRoute>
          }
        />
        <Route
          path="/ChooseIdCard"
          element={
            <PrivateRoute>
              <ChooseIdCard />
            </PrivateRoute>
          }
        />

        <Route
          path="/certificates/marksheet"
          element={
            <PrivateRoute>
              <CertificateMarksheet />
            </PrivateRoute>
          }
        />
        <Route
          path="/certificates/reportcard"
          element={
            <PrivateRoute>
              <CertificateReportcard />
            </PrivateRoute>
          }
        />
        <Route
          path="/certificates/admitcard"
          element={
            <PrivateRoute>
              <AdmitCard />
            </PrivateRoute>
          }
        />
        <Route
          path="/certificates/receipt"
          element={
            <PrivateRoute>
              <CertificateReceipt />
            </PrivateRoute>
          }
        />

        <Route
          path="/birthday/card"
          element={
            <PrivateRoute>
              <BirthdayCard />
            </PrivateRoute>
          }
        />

        <Route
          path="/rte"
          element={
            <PrivateRoute>
              <Rte />
            </PrivateRoute>
          }
        />

        <Route
          path="/payroll"
          element={
            <PrivateRoute>
              <PayRoll />
            </PrivateRoute>
          }
        />
        <Route
          path="/payroll/add"
          element={
            <PrivateRoute>
              <AddNewPayroll />
            </PrivateRoute>
          }
        />
        <Route
          path="/payroll/View"
          element={
            <PrivateRoute>
              <PayRollview />
            </PrivateRoute>
          }
        />

        <Route
          path="/GatePass"
          element={
            <PrivateRoute>
              <GatePass />
            </PrivateRoute>
          }
        />
        <Route
          path="/CreateGatePass"
          element={
            <PrivateRoute>
              <CreateGatePass />
            </PrivateRoute>
          }
        />
        <Route
          path="/CreateGateUpdate"
          element={
            <PrivateRoute>
              <GatePassupdata />
            </PrivateRoute>
          }
        />
        <Route
          path="/Followup"
          element={
            <PrivateRoute>
              <FollowUp />
            </PrivateRoute>
          }
        />
        <Route
          path="/AssignLeads"
          element={
            <PrivateRoute>
              <Assign />
            </PrivateRoute>
          }
        />
        <Route
          path="/CounselorCall"
          element={
            <PrivateRoute>
              <CounselorCall />
            </PrivateRoute>
          }
        />

        <Route
          path="/api/error"
          element={
            <PrivateRoute>
              <ApiNotFound />
            </PrivateRoute>
          }
        />
        <Route
          path="/api/access/denied"
          element={
            <PrivateRoute>
              <AccessDenied />
            </PrivateRoute>
          }
        />
        <Route
          path="/api/server"
          element={
            <PrivateRoute>
              <ServerError />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/portal"
          element={
            <PrivateRoute>
              <StudentPortal />
            </PrivateRoute>
          }
        />
        <Route
          path="/addmission/form"
          element={
            <PrivateRoute>
              <AddmissionForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/tests/add"
          element={
            <PrivateRoute>
              <ExamTest />
            </PrivateRoute>
          }
        />
        <Route
          path="/paper/typewriter"
          element={
            <PrivateRoute>
              <TypeWriter />
            </PrivateRoute>
          }
        />
        <Route
          path="/staff/schedule/create"
          element={
            <PrivateRoute>
              <ScheduleCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="/account/bank/add"
          element={
            <PrivateRoute>
              <BanksAdd />
            </PrivateRoute>
          }
        />
        <Route
          path="/fund/transfer"
          element={
            <PrivateRoute>
              <FundTarnsfer />
            </PrivateRoute>
          }
        />
        <Route path="/print" element={<Print />} />
        <Route path="/mock/dashboard" element={<Moketestdasbrd />} />
        <Route path="/mock/series" element={<TestSerieas />} />
        <Route path="/mock/create/test" element={<CreateMockTest />} />
        <Route path="/mock/test/list" element={<MockTestList />} />
        <Route path="/mock/test/panel" element={<OnlineTest />} />

        <Route
          path="/all/branch/list"
          element={
            <PrivateRoute>
              <AllBranchList />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/transfer/branch"
          element={
            <PrivateRoute>
              <StudentTransferBranch />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/transfer/list"
          element={
            <PrivateRoute>
              <StudentTransferList />
            </PrivateRoute>
          }
        />

        <Route
          path="/assignment"
          element={
            <PrivateRoute>
              <Assignment />
            </PrivateRoute>
          }
        />
        <Route
          path="/assignment/add"
          element={
            <PrivateRoute>
              <AssignmentAdd />
            </PrivateRoute>
          }
        />
        <Route
          path="/assignments/view"
          element={
            <PrivateRoute>
              <AssignmentView />
            </PrivateRoute>
          }
        />

        <Route
          path="/feedback"
          element={
            <PrivateRoute>
              <FeedbackView />
            </PrivateRoute>
          }
        />

        <Route
          path="/settings/razorpay"
          element={
            <PrivateRoute>
              <RazorpaySettings />
            </PrivateRoute>
          }
        />
        <Route
          path="/bus/live"
          element={
            <PrivateRoute>
              <BusListWithLocation />
            </PrivateRoute>
          }
        />
        <Route
          path="/bus/live/tracking/:id"
          element={
            <PrivateRoute>
              <BusLiveLocation />
            </PrivateRoute>
          }
        />
        <Route
          path="/notification/history"
          element={
            <PrivateRoute>
              <NotificationHistory />
            </PrivateRoute>
          }
        />
        <Route
          path="/distribution/kits"
          element={
            <PrivateRoute>
              <DistributionKitList />
            </PrivateRoute>
          }
        />
        <Route
          path="/distribution/kits/items"
          element={
            <PrivateRoute>
              <DistributionKitItems />
            </PrivateRoute>
          }
        />
        <Route
          path="/distribution-kits/report"
          element={
            <PrivateRoute>
              <DistributionReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/distribution-kits/payment"
          element={
            <PrivateRoute>
              <DistributionKitPayment />
            </PrivateRoute>
          }
        />

        <Route
          path="/distribution-kits/payment-receipt"
          element={
            <PrivateRoute>
              <DistributionKitPaymentReceipt />
            </PrivateRoute>
          }
        />
        <Route
          path="/notification/send"
          element={
            <PrivateRoute>
              <SendNotification />
            </PrivateRoute>
          }
        />
        <Route
          path="/students/import/profile-picture"
          element={
            <PrivateRoute>
              <StudentProfilePictureImport />
            </PrivateRoute>
          }
        />
        <Route
          path="/student/fees/transaction/history"
          element={
            <PrivateRoute>
              <PaymentTransactionHistory />
            </PrivateRoute>
          }
        />

        <Route
          path="/tests/syllabus"
          element={
            <PrivateRoute>
              <TestSyllabus />
            </PrivateRoute>
          }
        />

        <Route
          path="/settings/bank/transactions/:id"
          element={
            <PrivateRoute>
              <BankTransactionList />
            </PrivateRoute>
          }
        />

        <Route
          path="/students/update/bus-fee"
          element={
            <PrivateRoute>
              <BusFeeUpdate />
            </PrivateRoute>
          }
        />

        <Route
          path="/student/study-certificate"
          element={
            <PrivateRoute>
              <StudentStudyCertificate />
            </PrivateRoute>
          }
        />

        <Route
          path="/assignments/student-status"
          element={
            <PrivateRoute>
              <StudentAssignmentStatus />
            </PrivateRoute>
          }
        />

        <Route path="*" element={<PageError />} />
      </Routes>
    </Router>
  );
}

export default App;
